import { render, staticRenderFns } from "./saveCard.vue?vue&type=template&id=cffd4b74&scoped=true"
import script from "./saveCard.vue?vue&type=script&lang=js"
export * from "./saveCard.vue?vue&type=script&lang=js"
import style0 from "./saveCard.vue?vue&type=style&index=0&id=cffd4b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffd4b74",
  null
  
)

export default component.exports